module.exports = __webpack_public_path__ + "img/2.61ff51f0.png";